import { render, staticRenderFns } from "./Referral-program.vue?vue&type=template&id=bca31856&scoped=true"
import script from "./Referral-program.vue?vue&type=script&lang=js"
export * from "./Referral-program.vue?vue&type=script&lang=js"
import style0 from "./Referral-program.vue?vue&type=style&index=0&id=bca31856&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca31856",
  null
  
)

export default component.exports